<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs>
              <CTab :title="$t('requestProduct')">
                <AddOrder/>

              </CTab>
              <CTab :title="$t('myRequests')">
                <MyOrderList/>

              </CTab>
              <CTab :title="$t('yourRefers')">
                <AllOrderList/>

              </CTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
import BTabs from "../../tabs/BTabs";

import AddOrder from "@/views/panel/orders/AddOrder";
import AllOrderList from "@/views/panel/orders/AllReferedOrderList";
// import AllOrderListProducts from "@/views/panel/orders/AcceptedOrderListProducts";
// import BuyOrders from "@/views/panel/orders/BuyOrders";
// import InWayOrders from "@/views/panel/orders/InWayOrders";
import MyOrderList from "@/views/panel/orders/MyOrderList";
export default {
  name: 'Login',
  components: {
    BTabs,
    AddOrder,
    AllOrderList,
    // AllOrderListProducts,
    // BuyOrders,
    // InWayOrders,
    MyOrderList
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];


  }, watch: {

  },
  methods: {

  }
}

</script>
